import bilAPI from "./api";

// Passages: shared texts (a reading text, a table, a chart) that several questions are based on.
// A question links to at most one passage (`question.passage = {uuid, name}`); the exam shows the
// passage next to its questions. Lists never carry the body, the detail does.
// Reads: any bank role. Writes: create_question or create_exam.
const json = { headers: { "Content-Type": "application/json" } };

// params: page, page_size, search, subject, folder ("null" = no folder), author, ordering.
export const getPassages = ({ params, signal } = {}) =>
  bilAPI.get(`/questions/passages/`, { params, signal }).then((res) => res.data);

// {..list fields, body, questions: [{uuid, code, name, status, passage_order}], usage: {tests: [{uuid, name}]}}
export const getPassage = (uuid, { signal } = {}) =>
  bilAPI.get(`/questions/passages/${uuid}/`, { signal }).then((res) => res.data);

// data: {name, body?, subject_uuid?, folder_uuid?}
export const createPassage = (data) =>
  bilAPI.post(`/questions/passages/`, data, json).then((res) => res.data);

export const patchPassage = (uuid, data) =>
  bilAPI.patch(`/questions/passages/${uuid}/`, data, json).then((res) => res.data);

// 409 passage_has_questions while questions are linked.
export const deletePassage = (uuid) =>
  bilAPI.delete(`/questions/passages/${uuid}/`).then((res) => res.data);

// Replaces the linked questions; their order is the passage order. Unlinking questions that stand in
// tests answers 409 question_in_tests ({tests}) unless `confirm` is set. Returns the detail.
export const setPassageQuestions = (uuid, questions, { confirm = false } = {}) =>
  bilAPI
    .post(`/questions/passages/${uuid}/set_questions/`, { questions, ...(confirm ? { confirm: true } : {}) }, json)
    .then((res) => res.data);

// Replaces the body with a .docx file's content (tables, pictures and formulas are kept). Returns the detail.
export const uploadPassageBody = (uuid, file, { signal } = {}) => {
  const formData = new FormData();
  formData.append("file", file);
  return bilAPI.post(`/questions/passages/${uuid}/upload_body/`, formData, { signal }).then((res) => res.data);
};
